import Style from 'ol/style/Style';
import CircleStyle from 'ol/style/Circle';

import { Stroke } from 'cadenza/map/style/stroke';
import type { DrawInteraction } from 'cadenza/map/interactions/draw-interaction';
import type { ModifyInteraction } from 'cadenza/map/interactions/modify-interaction';

import type { StyleLike } from 'ol/style/Style';

export function createSnapStyle () {
  return new Style({
    image: new CircleStyle({
      radius: 5,
      stroke: new Stroke({
        color: [ 255, 0, 0 ],
        width: 2
      })
    }),
    zIndex: Infinity
  });
}

export function updateOverlayStyle (snapped: boolean, interaction: DrawInteraction | ModifyInteraction, style: StyleLike, snapStyle: StyleLike) {
  const currentStyle = interaction.getOverlay().getStyle();
  if (snapped && currentStyle !== snapStyle) {
    interaction.getOverlay().setStyle(snapStyle);
  }
  if (!snapped && currentStyle === snapStyle) {
    interaction.getOverlay().setStyle(style);
  }
}
